<template>
  <div v-if="canExport">
    <json-excel
      class="btn btn-default"
      :name="nameFile"
      :title="title"
      :fields="assessmentType == 'sgd-assessment' ? json_fields_additional_score : json_fields"
      :escapeCsv="true"
      type="csv"
      :before-generate="beforeGenerate"
      :before-finish="beforeFinish"
      :fetch="doExport"
    >
      <el-tooltip placement="top" :content="$t('information.export_assessment_button')">
        <chip class="export-assessment" :type="buttonType" v-loading.fullscreen.lock="exportLoading">
          {{ $t("common.export_assessment") }}
        </chip>
      </el-tooltip>
    </json-excel>
  </div>
</template>

<script>
import showNoReportDataWarning from "@/components/common/mixins/noReportData";
import { isSessionExpireError } from "@/utils/sessionExpireErr";
import Chip from "@/components/common/Chip";
import JsonExcel from "@/components/lib/JsonExcel";
import { format, toDate, startOfMonth } from "date-fns";
import { mapGetters, mapActions, mapState } from "vuex";
import { warningMessage, successMessage } from "@/utils/messages";
import { pathOr, length, join, prop, compose, concat, __ } from "ramda";
export default {
  mixins: [showNoReportDataWarning],
  components: {
    Chip,
    JsonExcel,
  },
  props: {
    startDate: {
      default: () => startOfMonth(Date.now()),
    },
    endDate: {
      default: () => toDate(Date.now()),
    },
    scope: {
      default: "daily",
    },
    canExport: {
      default: false,
    },
    usersSelected: {
      type: Array,
      default: () => [],
    },
    buttonType: {
      type: String,
      default: "",
    },
    assessmentType: {
      type: String,
      default: "general",
    },
  },
  data() {
    return {
      json_fields: {
        "Student Name": "student_name",
        "Student Email": "student_email",
        "Last Assessment Date": "date_assessment",
        "Last Assessment Score": "assessment_test_eps",
        Pronunciation: "ons",
        Intonation: "sis",
        Fluency: "fls",
        Skill: "skill",
        "Score per Skill": "score_skill",
      },
      json_fields_additional_score: {
        "Student Name": "student_name",
        "Student Email": "student_email",
        "Assessment Date": "date_assessment",
        "Assessment Score": "overall",
        Pronunciation: "pronunciation",
        Intonation: "intonation",
        "Word Linkage": "word_linkage",
        "Ending Sounds": "ending_sounds",
        Pausing: "pausing",
        Pace: "pace",
        Text: "text",
        Volume: "volume",
      },
      exportLoading: false,
    };
  },
  destroyed() {
    this.$store.dispatch("classes/resetExportAssessmentData");
  },
  methods: {
    getAllExportData(options) {
      return this.getExportAssessmentData(options).catch(err => {
        if (!isSessionExpireError(err)) this.showNoReportDataWarning();
      });
    },
    ...mapActions({ getCurrentClassAllUsers: "classes/getCurrentClassAllUsers" }),
    ...mapActions("classes", ["getExportAssessmentData"]),
    async doExport() {
      try {
        let studentRequets = [];
        if (this.usersSelected.length > 0) {
          // export for user selected
          for (let i = 0; i < this.usersSelected.length; i++) {
            let options = {
              student: this.usersSelected[i].user,
              from: this.startDate,
              to: this.endDate,
              assessment_type: this.assessmentType,
            };
            studentRequets.push(this.getAllExportData(options));
          }
        } else {
          // export all user
          await this.getCurrentClassAllUsers();
          for (let i = 0; i < this.currentClassAllStudent.length; i++) {
            let student = this.currentClassAllStudent[i]["user"];
            let options = {
              student: student,
              from: this.startDate,
              to: this.endDate,
              assessment_type: this.assessmentType,
            };
            studentRequets.push(this.getAllExportData(options));
          }
        }
        if (!length(this.exportAssessmentData)) {
          return Promise.all(studentRequets).then(resp => {
            if (this.exportAssessmentData.length > 0) {
              return this.exportAssessmentData;
            } else {
              this.handleWithoutData();
            }
          });
        }
        try {
          this.$gtag.event(`${document.title}-export assessment`, {
            category: `Export`,
            label: `Export Assessment`,
          });
        } catch (error) {
          error;
        }
        return this.exportAssessmentData.map(data => {
          return {
            ...data,
            last_active: data["date_assessment"]
              ? `${data["date_assessment"].split(" ")[0]} ${format(
                  new Date(data["date_assessment"].split(" ")[1]),
                  "dd MMM yyyy"
                )}`
              : "",
          };
        });
      } catch (error) {
        error;
      }
    },
    handleWithoutData() {
      const message = this.$t("common.no_assessment_test_in_periods");
      this.exportLoading = false;
      successMessage(this.$t(message))(this);
    },
    beforeGenerate() {
      return (this.exportLoading = true);
    },
    beforeFinish() {
      return (this.exportLoading = false);
    },
  },
  computed: {
    ...mapState("classes", ["exportAssessmentData"]),
    ...mapGetters({
      getCurrentClass: "classes/getCurrentClass",
      currentClassAllStudent: "classes/getCurrentClassAllStudent",
    }),
    ...mapGetters("students", ["paginateStudents"]),
    title() {
      const formatedStartDate = format(new Date(this.startDate), "dd MMM yyyy");
      const formatedEndDate = format(new Date(this.endDate), "dd MMM yyyy");
      let titleTime = `${formatedStartDate} - ${formatedEndDate}`;
      return [`${this.getCurrentClass.name} Assessment Report`, titleTime];
    },
    nameFile: compose(concat(__, ".csv"), join(" "), prop("title")),
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "../../scss/_colors.scss";
.export-assessment {
  margin-right: 10px;
  padding: 11px 11px;
}
</style>
